import { ReactChildrenProp } from "global";
import React, { createContext, useContext, useEffect, useState } from "react";
import { MIN_SCREEN_WIDTH } from "../../../utils/constants";

interface ScreenWidthContextValue {
  screenWidth: number;
  screenHeight: number;
  isPc: boolean;
  isMobile: boolean;
}

const initialValue: ScreenWidthContextValue = {
  screenWidth: 0,
  screenHeight: 0,
  isPc: false,
  isMobile: false,
};

const ScreenWidthContext = createContext<ScreenWidthContextValue>(initialValue);

function ScreenWidthProvider({ children }: ReactChildrenProp) {
  const [value, setValue] = useState<ScreenWidthContextValue>(initialValue);

  function handleResize() {
    const currentWidth = window.innerWidth;
    const currentHeight = window.innerHeight;

    if (currentWidth >= MIN_SCREEN_WIDTH.DESKTOP) {
      setValue({
        screenWidth: currentWidth,
        screenHeight: currentHeight,
        isPc: true,
        isMobile: false,
      });
    } else {
      setValue({
        screenWidth: currentWidth,
        screenHeight: currentHeight,
        isPc: false,
        isMobile: true,
      });
    }
  }

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <ScreenWidthContext.Provider value={value}>
      {children}
    </ScreenWidthContext.Provider>
  );
}

export default ScreenWidthProvider;

export function useScreenWidthContext() {
  return useContext(ScreenWidthContext);
}
